
    export default 
    {
    "banner_v2": {
        "title": "<span class={title}>Erhalten Sie <span class={highlight}>$100</span> und mehr während der DSers Reward Season</span>",
        "desc": "Die DSers Reward Season wird vom 15. Oktober bis zum 15. Januar stattfinden.<br /> Die Einladungen werden im September an zufällig ausgewählte Händler verschickt. <br />Bitte überprüfen Sie die Mailbox der E-Mail, die Sie zur Erstellung Ihres DSers-Kontos verwendet haben.",
        "learn_more": "Mehr erfahren"
    }
}